import React from "react";
import { Modal, Button } from "react-bootstrap";

const CakeCustomizationModal = ({ open, onClose, customization }) => {
  return (
    <Modal show={open} onHide={onClose} centered size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold text-primary">Cake Customization</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!customization ? (
          <p className="text-muted text-center my-3">No customization available.</p>
        ) : (
          <div className="container-fluid">
            <div className="row">
              {/* Text Details */}
              <div className="col-md-6">
                {customization["Celebrity Name"] && (
                  <p>
                    <strong>Celebrity Name:</strong> {customization["Celebrity Name"]}
                  </p>
                )}
                {(customization.size || customization.Size) && (
                  <p>
                    <strong>Size:</strong> {customization.size || customization.Size}
                  </p>
                )}
                {(customization.shape || customization.Shape) && (
                  <p>
                    <strong>Shape:</strong> {customization.shape || customization.Shape}
                  </p>
                )}
                {(customization.occasion || customization.Occasion) && (
                  <p>
                    <strong>Occasion:</strong> {customization.occasion || customization.Occasion}
                  </p>
                )}
                {(customization.flavour || customization.Flavour) && (
                  <p>
                    <strong>Flavour:</strong> {customization.flavour || customization.Flavour}
                  </p>
                )}
              </div>

              {/* Image Section */}
              <div className="col-md-6 d-flex justify-content-center align-items-center rounded " style={{border:"1px dashed #000"}}>
                {customization.image ? (
                  <img
                    src={customization.image}
                    alt="Cake"
                    className="img-fluid rounded shadow-sm"
                    style={{ maxHeight: "300px" }}
                  />
                ) : (
                  <p className="text-muted text-center">Customer did not provide an image</p>
                )}
              </div>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CakeCustomizationModal;
